export type StepupView = 'enroll' | 'verify'

export interface MethodsSnapshot {
  totp_enabled: boolean
  email_otp_enabled: boolean
  recovery_codes_remaining: number
}

/** Which form the step-up sheet shows. A user with no usable method must enrol one first
 *  (otherwise every code is rejected); a failed methods fetch never blocks the verify form. */
export function stepupView(m: MethodsSnapshot | null): StepupView {
  if (!m) return 'verify'
  return m.totp_enabled || m.email_otp_enabled || m.recovery_codes_remaining > 0 ? 'verify' : 'enroll'
}

export type StepupErrorKey = 'wrong' | 'rateLimited' | 'emailUnavailable' | 'network' | 'failed'

/** Maps a thrown error to an i18n key under `mobile.stepup.errors`. */
export function stepupErrorKey(e: unknown): StepupErrorKey {
  if (e instanceof TypeError) return 'network'
  const status = (e as { status?: unknown } | null)?.status
  if (status === 429) return 'rateLimited'
  if (status === 503) return 'emailUnavailable'
  if (status === 400 || status === 401) return 'wrong'
  return 'failed'
}
